/* Gender menus. Desktop mega-menu panels (snippets/header-gender-panel.liquid): switches the category rail's tabs.
   Click and focus switch at once; hovering a tab switches after 120 ms, cancelled if the pointer leaves that tab first
   (so a diagonal move toward the tiles does not flip categories); ArrowUp / ArrowDown / Home / End move between tabs.
   The first tab is selected again whenever the menu closes. Opening and closing the menu stays with theme.js hoverMenu. */
(function () {
  'use strict';
  var HOVER_DELAY = 120;
  var TAB = '[role="tab"]';

  function tabsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll(TAB));
  }

  function select(root, tab) {
    tabsOf(root).forEach(function (t) {
      var on = t === tab;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) t.removeAttribute('tabindex');
      else t.setAttribute('tabindex', '-1');
      if (panel) panel.hidden = !on;
    });
  }

  function init(root) {
    if (root.hasAttribute('data-gender-panel-ready')) return;
    root.setAttribute('data-gender-panel-ready', '');
    var timer = 0;
    var pending = null;

    function cancel() {
      clearTimeout(timer);
      timer = 0;
      pending = null;
    }

    function tabFrom(event) {
      var tab = event.target && event.target.closest ? event.target.closest(TAB) : null;
      return tab && root.contains(tab) ? tab : null;
    }

    function selectNow(event) {
      var tab = tabFrom(event);
      if (!tab) return;
      cancel();
      if (tab.getAttribute('aria-selected') !== 'true') select(root, tab);
    }

    root.addEventListener('click', selectNow);
    root.addEventListener('focusin', selectNow);

    // mouseenter / mouseleave do not bubble, but they do pass through the capture phase of the ancestors
    root.addEventListener('mouseenter', function (event) {
      var tab = event.target;
      if (!tab.matches || !tab.matches(TAB)) return;
      cancel();
      if (tab.getAttribute('aria-selected') === 'true') return;
      pending = tab;
      timer = setTimeout(function () {
        timer = 0;
        pending = null;
        select(root, tab);
      }, HOVER_DELAY);
    }, true);
    root.addEventListener('mouseleave', function (event) {
      if (pending && event.target === pending) cancel();
    }, true);

    root.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;   // leave browser shortcuts (Alt+arrow = back/forward) alone
      var tab = tabFrom(event);
      if (!tab) return;
      var tabs = tabsOf(root);
      var i = tabs.indexOf(tab);
      var next = null;
      if (event.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
      else if (event.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      cancel();
      select(root, next);
      next.focus();
    });

    var details = root.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        var first = root.querySelector(TAB);
        if (details.open || !first) return;
        cancel();
        select(root, first);
      });
    }
  }

  /* Mobile drawer audience tabs (snippets/drawer-gender-tabs.liquid, inside #NavDrawer).
     Tabs: click selects; ArrowLeft / ArrowRight / Home / End move and select (roving tabindex). Selecting a tab closes
     any open slide. A category row opens its slide (class is-open, aria-expanded, focus to the slide heading); Back and
     Esc close it (focus back to the row). theme.js reacts to Esc twice: a document keydown blurs the focused element
     (predictive-search:close-all) and a window keyup closes the whole drawer. So while a slide is open, Esc is handled
     on the drawer's keydown, which stops there, and the keyup that follows stops at the drawer too.
     When the drawer closes (#NavDrawer loses drawer--is-open) the first tab is selected again with no slide open, after
     the 500 ms close animation, or at once if the drawer reopens first. */
  var DG_ROW = '.drawer-gender__row';

  function dgInit(root) {
    if (root.hasAttribute('data-drawer-gender-ready')) return;
    root.setAttribute('data-drawer-gender-ready', '');
    var drawer = root.closest('.drawer');
    var scroller = root.closest('.drawer__scrollable');
    var resetTimer = 0;

    function dgTabs() {
      return tabsOf(root.querySelector('[role="tablist"]') || root);
    }

    function openRow() {
      return root.querySelector(DG_ROW + '[aria-expanded="true"]');
    }

    function closeSlide(focusRow) {
      var row = openRow();
      if (!row) return;
      var slide = document.getElementById(row.getAttribute('aria-controls'));
      row.setAttribute('aria-expanded', 'false');
      if (slide) {
        slide.classList.remove('is-open');
        slide.hidden = true;
      }
      root.classList.remove('is-drilled');
      if (focusRow) row.focus();
    }

    function openSlide(row) {
      var slide = document.getElementById(row.getAttribute('aria-controls'));
      if (!slide) return;
      closeSlide(false);
      row.setAttribute('aria-expanded', 'true');
      root.classList.add('is-drilled');
      slide.hidden = false;
      slide.classList.add('is-open');
      if (scroller) scroller.scrollTop = 0;
      var heading = slide.querySelector('.drawer-gender__title');
      if (heading) heading.focus({ preventScroll: true });
    }

    function dgSelect(tab) {
      closeSlide(false);
      dgTabs().forEach(function (t) {
        var on = t === tab;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) t.removeAttribute('tabindex');
        else t.setAttribute('tabindex', '-1');
        if (panel) panel.hidden = !on;
      });
    }

    function reset() {
      clearTimeout(resetTimer);
      resetTimer = 0;
      var first = dgTabs()[0];
      if (first) dgSelect(first);
    }

    root.addEventListener('click', function (event) {
      var hit = event.target && event.target.closest ? event.target.closest(TAB + ', ' + DG_ROW + ', .drawer-gender__back') : null;
      if (!hit || !root.contains(hit)) return;
      if (hit.matches(TAB)) dgSelect(hit);
      else if (hit.matches(DG_ROW)) openSlide(hit);
      else closeSlide(true);
    });

    root.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      var tab = event.target && event.target.closest ? event.target.closest(TAB) : null;
      if (!tab || !root.contains(tab)) return;
      var tabs = dgTabs();
      var i = tabs.indexOf(tab);
      var next = null;
      if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      dgSelect(next);
      next.focus();
    });

    if (drawer) {
      var swallowEsc = false;
      drawer.addEventListener('keydown', function (event) {
        swallowEsc = false;
        if ((event.key !== 'Escape' && event.key !== 'Esc') || !openRow()) return;
        event.stopPropagation();
        swallowEsc = true;
        closeSlide(true);
      });
      drawer.addEventListener('keyup', function (event) {
        if ((event.key !== 'Escape' && event.key !== 'Esc') || !swallowEsc) return;
        swallowEsc = false;
        event.stopPropagation();
      });
      if (window.MutationObserver) {
        var wasOpen = drawer.classList.contains('drawer--is-open');
        new MutationObserver(function () {
          var open = drawer.classList.contains('drawer--is-open');
          if (open === wasOpen) return;
          wasOpen = open;
          if (open) {
            if (resetTimer) reset();
          } else {
            clearTimeout(resetTimer);
            resetTimer = setTimeout(reset, 500);
          }
        }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  /* Product media for both menus (sections/nav-gender-media.liquid). The panels and the drawer render placeholders
     (data-ngm-thumb / data-ngm-feature / data-ngm-trend = a category collection handle) so the page itself reads no
     product - Shopify lists every product a page renders in its inline analytics payload. The JSON is fetched once
     (Section Rendering API) after the page loads, or at once when a menu opens first, and kept for the session
     (sessionStorage, 30 min, per theme). A failed fetch leaves the placeholders empty and retries on the next open. */
  var NGM_TTL = 30 * 60 * 1000;
  var NGM_SLOTS = '[data-ngm-thumb],[data-ngm-feature],[data-ngm-trend]';
  var ngmState = 0;            // 0 = not loaded, 1 = loading, 2 = applied
  var ngmCats = null;
  var ngmTries = 0;            // a failed fetch retries on the next hover / tap, at most 3 fetches per page

  function ngmEl(tag, attrs, text) {
    var node = document.createElement(tag);
    for (var k in attrs) if (attrs[k] != null) node.setAttribute(k, attrs[k]);
    if (text != null) node.textContent = text;
    return node;
  }

  function ngmImg(src, w, h, alt) {
    return ngmEl('img', { src: src, width: w, height: h, alt: alt || '', loading: 'lazy', decoding: 'async' });
  }

  function ngmEach(attr, fn) {
    Array.prototype.forEach.call(document.querySelectorAll('[' + attr + ']'), function (slot) {
      var cat = ngmCats[slot.getAttribute(attr)];
      if (cat) fn(slot, cat);
    });
  }

  function ngmApply() {
    ngmEach('data-ngm-thumb', function (slot, cat) {
      if (cat.thumb && !slot.querySelector('img')) slot.appendChild(ngmImg(cat.thumb, 46, 46));
    });
    ngmEach('data-ngm-feature', function (slot, cat) {
      // the image opens the product (the collection's "Menu feature product", else its top seller); the label and
      // "Shop now" open the whole category sorted best-selling
      var p = cat.feature || (cat.products && cat.products[0]);
      if (!p || slot.firstChild) return;
      var shopUrl = cat.shop || p.url;
      var card = ngmEl('div', { 'class': 'gp-feature' });
      var media = ngmEl('a', { 'class': 'gp-feature__media', href: p.url });
      if (p.img_m) media.appendChild(ngmImg(p.img_m, 268, 330, p.title));
      media.appendChild(ngmEl('span', { 'class': 'gp-badge' }, cat.badge));
      card.appendChild(media);
      card.appendChild(ngmEl('a', { 'class': 'gp-feature__label', href: shopUrl }, cat.label));
      card.appendChild(ngmEl('a', { 'class': 'gp-feature__cta', href: shopUrl }, 'Shop now'));
      slot.appendChild(card);
    });
    ngmEach('data-ngm-trend', function (slot, cat) {
      if (slot.firstChild || !cat.products) return;
      var drawer = slot.getAttribute('data-ngm-style') === 'drawer';
      var count = parseInt(slot.getAttribute('data-ngm-count'), 10) || 4;
      cat.products.slice(0, count).forEach(function (p) {
        var a = ngmEl('a', { href: p.url });
        var src = drawer ? (p.img_s || p.img) : p.img;
        if (src) a.appendChild(drawer ? ngmImg(src, 118, 140) : ngmImg(src, 300, 190));
        a.appendChild(ngmEl('span', null, p.title));
        if (!drawer) a.appendChild(ngmEl('span', { 'class': 'gp-price' }, p.price));
        slot.appendChild(a);
      });
    });
  }

  function ngmUse(cats) {
    ngmCats = cats;
    ngmState = 2;
    ngmApply();
  }

  function ngmLoad() {
    if (ngmState || ngmTries >= 3) return;
    if (!document.querySelector(NGM_SLOTS)) return;
    ngmState = 1;
    var shop = window.Shopify || {};
    var root = (shop.routes && shop.routes.root) || '/';
    // per theme, market path and currency: /en-ca/ links and CAD prices must not be served to a US page or vice versa
    var key = 'bc-ngm2:' + (shop.theme && shop.theme.id ? shop.theme.id : '') + ':' + root + ':' +
      (shop.currency && shop.currency.active ? shop.currency.active : '');
    var hit = null;
    try { hit = JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch (e) { hit = null; }
    if (hit && hit.cats && Date.now() - hit.t < NGM_TTL) {
      ngmUse(hit.cats);
      return;
    }
    ngmTries++;
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : 0;
    fetch(root + '?section_id=nav-gender-media', { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error('nav-gender-media ' + r.status);
        return r.text();
      })
      .then(function (html) {
        clearTimeout(timer);
        var m = html.match(/<script type="application\/json" data-ngm>([\s\S]*?)<\/script>/);
        var data = JSON.parse(m ? m[1] : '');
        try { window.sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), cats: data.cats })); } catch (e) { /* storage off */ }
        ngmUse(data.cats);
      })
      .catch(function () { clearTimeout(timer); ngmState = 0; });
  }

  function ngmSchedule() {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 300); };
    var go = function () { idle(ngmLoad, { timeout: 2500 }); };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go);
    // a menu opened before then loads at once: desktop hover / focus / toggle on a gender item, the mobile drawer
    Array.prototype.forEach.call(document.querySelectorAll('[data-gender-panel]'), function (panel) {
      var item = panel.closest('.site-nav__item') || panel;
      item.addEventListener('mouseenter', ngmLoad);
      item.addEventListener('focusin', ngmLoad);
      var details = panel.closest('details');
      if (details) details.addEventListener('toggle', ngmLoad);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[aria-controls="NavDrawer"]'), function (btn) {
      btn.addEventListener('click', ngmLoad);
      btn.addEventListener('touchstart', ngmLoad, { passive: true });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gender-panel]'), init);
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-gender]'), dgInit);
    if (ngmCats) ngmApply();     // theme editor re-rendered the header: refill the new placeholders
  }

  initAll();
  ngmSchedule();
  document.addEventListener('shopify:section:load', initAll);
})();
